/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, {useState, useEffect} from 'react';
import {  useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { update_event_details_sellerPackage, get_event_details, messageClear } from '../store/reducers/eventDetailsReducer';

import { currencyFormat } from '../components/CurrencyFormat';
import toast from 'react-hot-toast';

import config from '../config';

const Accordion = ({title, intro, pricePerPerson, minNumberPeople, description, showSetSellerPackageButton}) => {
    const { loader,  userInfo } = useSelector(state => state.auth);
    const { eventDetails, errorMessage, successMessage } = useSelector(state => state.eventDetails);
    const { seller } = useSelector(state => state.seller)
    const [accordionOpen, setAccordionOpen] = useState(false)
    
    const sellerId = seller._id 
    const sellerPrimaryColor1 = seller.frontEndPrimaryColor1
    const sellerPrimaryColor2 =  seller.frontEndPrimaryColor2
    const sellerSecondaryColor1 = seller.frontEndSecondaryColor1
    //console.log(description)

    const navigate = useNavigate();
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(get_event_details(userInfo.id))
    },[userInfo.id])

    //let [state, setState] = useState({
            // webSiteOrigin: sellerFrontendURL, 
            // name: userInfo.name, 
            // phoneNumber: userInfo.phoneNumber,
            // email: userInfo.email //, password: ''
    //})
    const update_event_details_sellerPackage_local = () => {
        //console.log(pro)
        dispatch(update_event_details_sellerPackage({
            customerId: userInfo.id,
            title: title
        }))
        // dispatch(get_event_details(userInfo.id))
        // console.log(eventDetails?.selectedSellerPackage)
    }

    //  useEffect(() => { 
    //     if (successMessage) {
    //         toast.success(successMessage)
    //         dispatch(messageClear())  
    //     } 
    //     if (errorMessage) {
    //         toast.error(errorMessage)
    //         dispatch(messageClear())  
    //     } 
    // },[successMessage, errorMessage])

    try {
        description = description.replaceAll("<li>", "<li style='margin-left:12px;'>")//<span>&#46;</span>
        description = description.replaceAll("<ul>", "<ul style='list-style-type: disc; margin-left:10px;'>")//<span>&#46;</span>
    } catch (error) {
        
    }
   
    return (
        <div className='py-0' >
            {
                //bg-gray-200
                //hover:pl-1 hover:pr-1 hover:pt-1 bg-gray-200
                //style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}
            }
            <button onClick={() => setAccordionOpen(!accordionOpen)} 
                className='hover:bg-gray-300 hover:rounded-lg pl-2 pt-1 hover:pl-2 hover:pt-1
                    flex justify-between w-full cursor-hand rounded-lg'>
                <span className='font-bold' style={{color:sellerPrimaryColor1}}>{title}</span>
                {   /*accordionOpen ? <span>-</span> : <span>+</span>*/
                    //mt-2 mb-2 mr-2 fill-indigo-500
                }
                <svg className=" shrink-0 ml-8 mt-2 mb-2 mr-2" width="16" height="16" xmlns="http://www.w3.org/2000/svg"
                    style={{fill:sellerPrimaryColor1}}>
                    <rect y="7" width="16" height="2" rx="1"
                        className={`transform origin-center transition duration-200 ease-out ${
                            accordionOpen && "!rotate-180"
                        }`} />
                    <rect y="7" width="16" height="2" rx="1"
                        className={`transform origin-center rotate-90 transition duration-200 ease-out ${
                            accordionOpen && "!rotate-180"
                        }`} />
                </svg>
            </button>
            {/* bg-gray-300 text-slate-600  items-center place-items-center */}
            <div className={` w-[98%] border-2 rounded-lg ml-1 mr-1 mt-2 mb-1 grid overflow-hidden translate-all 
                duration-300 ease-in-out text-sm justify-start 
                 ${accordionOpen ? 'grid-rows-[1fr] opacity-100 p-3' : 'grid-rows-[0fr] opacity-0'} `}
                style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
                <div className='overflow-hidden'>
                    <div className='flex md:flex-col md:gap-2 gap-1'>
                        <div className='mb-2 border-none pr-1 font-semibold'>{intro}</div>
                    </div>
                    <div className={` ${showSetSellerPackageButton ? '' : 'hidden' }  flex md:flex-col md:gap-2 gap-1`}>
                        <button onClick={update_event_details_sellerPackage_local} className='text-white py-1 px-2 rounded-lg'
                            style={{backgroundColor:sellerPrimaryColor1}}>
                            Set As My Package
                        </button>
                    </div>
                    <div className='flex md:flex-col md:gap-2 gap-1'>
                        <div className='grid grid-cols-2 gap-1 mb-2 border-none pr-1'>
                            <span>Price Per Person: </span><span className='font-semibold'>{currencyFormat.format(pricePerPerson)}</span> 
                        </div>
                        <div className='grid grid-cols-2 gap-1 mb-2 border-none p-0'>
                            <span>Minimum Number People: </span><span className='font-semibold'>{minNumberPeople}</span>
                        </div>
                    </div>
                    <div dangerouslySetInnerHTML={{__html: description}} />
                </div>
            </div>
        </div>
    );
};

export default Accordion